import { render, staticRenderFns } from "./CurrencyView.vue?vue&type=template&id=24863028"
import script from "./CurrencyView.vue?vue&type=script&lang=js"
export * from "./CurrencyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports